import { useQuery } from '@tanstack/react-query';
import { apiClient } from './client';
import type { RevenueResponse } from '@/types/api';

export interface PvRevenueParams {
  station: string;
  start_date: string;
  end_date: string;
}

export interface StorageRevenueParams {
  station: string;
  start_date: string;
  end_date: string;
  penalty_base: number;
  cap_max: number;
  eff: number;
  curt_thres: number;
}

export function usePvRevenue(params: PvRevenueParams) {
  return useQuery({
    queryKey: ['revenue', 'pv', params],
    queryFn: async () => {
      const res = await apiClient.get<RevenueResponse>('/revenue/pv', {
        params: {
          station: params.station,
          start_date: params.start_date,
          end_date: params.end_date,
        },
      });
      return res.data;
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
    enabled: !!params.station && !!params.start_date && !!params.end_date,
  });
}

export function useStorageRevenue(params: StorageRevenueParams) {
  return useQuery({
    queryKey: ['revenue', 'storage', params],
    queryFn: async () => {
      const res = await apiClient.get<RevenueResponse>('/revenue/storage', {
        params: {
          station: params.station,
          start_date: params.start_date,
          end_date: params.end_date,
          penalty_base: params.penalty_base,
          cap_max: params.cap_max,
          eff: params.eff,
          curt_thres: params.curt_thres,
        },
      });
      return res.data;
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
    enabled: !!params.station && !!params.start_date && !!params.end_date,
  });
}
